<template>
  <div class="subheader clearfix">
    <span class="col-xs-4" @click="updateContext('patient')">
      <img src="~assets/images/Patient_Text.png" class="img-responsive" :class="patientContext">
    </span>
    <span class="col-xs-4" @click="updateContext('practice')">
      <img src="~assets/images/Practice_Text.png" class="img-responsive" :class="practiceContext">
    </span>
    <span class="col-xs-4" @click="updateContext('academic')">
      <img src="~assets/images/Academic_Text.png" class="img-responsive" :class="academicContext">
    </span>
  </div>
</template>

<script>
  export default {
    name: 'context-selector',
    computed: {
      context() {
        return this.$store.state.context;
      },
      patientContext() {
        return {
          active: this.context === 'patient',
          inactive: this.context !== 'patient',
        };
      },
      practiceContext() {
        return {
          active: this.context === 'practice',
          inactive: this.context !== 'practice',
        };
      },
      academicContext() {
        return {
          active: this.context === 'academic',
          inactive: this.context !== 'academic',
        };
      },
    },
    methods: {
      updateContext(newContext) {
        this.$store.dispatch('updateContext', {
          context: newContext,
        });
        this.$parent.$emit('changeContext', {
          context: newContext,
        });
      },
    },
  };

</script>

<style scoped>
  .inactive {
    transition: all 0.3s ease-in-out;
    filter: grayscale(100%);
    transform: scale(0.70, 0.70);
  }

  .inactive:hover {
    filter: grayscale(50%);
  }

  .active {
    transition: all 0.3s ease-in-out;
    filter: grayscale(0%);
    transform: scale(1, 1);
  }
</style>



// WEBPACK FOOTER //
// ContextSelector.vue?32e0a5c2